module.exports = __webpack_public_path__ + "img/25200.bc4fcedc.jpg";